import { DatastoreInterface } from '@freelancer/datastore/core';
import { Language } from './languages.model';
import { LanguagesCollection } from './languages.types';

export async function createLanguages(datastore: DatastoreInterface) {
  const object = generateLanguagesObject();
  await datastore.createRawDocument<LanguagesCollection>('languages', object);
  return object;
}

function generateLanguagesObject(): Language {
  return {
    id: 'en',
    code: 'en',
    name: 'English',
    englishName: 'English',
    active: true,
  };
}
